import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertComponent } from './components/alert/alert.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { DeviceViewComponent } from './components/device-view/device-view.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HelpMenuComponent } from './components/help-menu/help-menu.component';
import { IconComponent } from './components/icon/icon.component';
import { ListModule } from './components/list/list.module';
import { MaterialModule } from '../material.module';
import { PapaParseModule } from 'ngx-papaparse';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectedNodesPanelComponent } from './components/selected-nodes-panel/selected-nodes-panel.component';
import { SliderModule } from './components/slider/slider.module';
import { UserProfilePinComponent } from './components/user-profile-pin/user-profile-pin.component';
import { WidgetComponent } from './components/widget/widget.component';
import { ZendeskConfigModule } from '../zendesk-config.module';
import { ButtonsModule } from './components/buttons/buttons.module';
import { TreeModule } from './components/tree/tree.module';
import { CardsModule } from './components/cards/cards.module';
import { LocalFormsModule } from './components/local-forms/forms.module';
import { DirectivesModule } from './directives/directives.module';
import { ProgressIndictatorsModule } from './components/progress-indicators/progress-indicators.module';
import { PipesModule } from './pipes/pipes.module';
import { TabsModule } from './components/tabs/tabs.module';
import { ColumnModule } from './components/column/column.module';
import { SortComponent } from './components/sort/sort.component';
import { SwatchItemComponent } from './components/swatch-item/swatch-item.component';

@NgModule({
  imports: [
    ButtonsModule,
    CardsModule,
    ColorPickerModule,
    ColumnModule,
    CommonModule,
    DirectivesModule,
    FontAwesomeModule,
    LocalFormsModule,
    ListModule,
    MaterialModule,
    PapaParseModule,
    PipesModule,
    ProgressIndictatorsModule,
    ReactiveFormsModule,
    SliderModule,
    TabsModule,
    TreeModule,
    ZendeskConfigModule,
  ],
  declarations: [
    AlertComponent,
    ColorPickerComponent,
    DeviceViewComponent,
    HelpMenuComponent,
    IconComponent,
    SelectedNodesPanelComponent,
    UserProfilePinComponent,
    WidgetComponent,
    SortComponent,
    SwatchItemComponent
  ],
  exports: [
    AlertComponent,
    ButtonsModule,
    CardsModule,
    ColorPickerComponent,
    ColumnModule,
    DeviceViewComponent,
    DirectivesModule,
    LocalFormsModule,
    HelpMenuComponent,
    IconComponent,
    ListModule,
    PipesModule,
    ProgressIndictatorsModule,
    SelectedNodesPanelComponent,
    SliderModule,
    TabsModule,
    TreeModule,
    UserProfilePinComponent,
    WidgetComponent,
    SortComponent,
    SwatchItemComponent
  ],
  entryComponents: []
})
export class SharedModule { }
